import React from 'react';
import cx from 'classnames';
import {Map} from 'immutable';
import {shapes, svgs} from '../../../constants';
import Avatar from '../../avatar/Avatar';
import Icon from '../../icon/Icon';
//@ts-ignore
import styles from './DefaultToastItem.pcss';

interface IconInterface {
    ariaLabel: string;
    backgroundColor: string;
    icon: string | Map<any, any>;
    shape: shapes;
}

interface IconMap extends Map<string, any> {
    toJS(): IconInterface;
    get<K extends keyof IconInterface>(key: K): IconInterface[K];
}

interface AvatarInterface {
    avatar: any;
    backgroundColor?: string;
    displayName: string;
    initialColor?: string;
}

export interface AssetProps {
    avatar: AvatarInterface;
    icon: IconMap;
    isError: boolean;
}

const Asset = ({avatar, icon, isError}: AssetProps) => {
    if (isError) {
        return (
            <Icon
                className={cx(styles.asset, styles.assetError)}
                icon={svgs.CLOSE}
                type={shapes.ROUND}
            />
        );
    }

    if (avatar) {
        return (
            <Avatar
                avatar={avatar.avatar}
                backgroundColor={avatar.backgroundColor}
                className={styles.asset}
                displayName={avatar.displayName}
                initialColor={avatar.initialColor}
            />
        );
    }

    if (icon) {
        // TODO replace with Immer or refactor Icon.js to receive a string constant instead of object
        const iconVal = icon.get('icon');
        const iconData = typeof iconVal === 'string' ? iconVal : iconVal.toJS();

        return (
            <Icon
                ariaLabel={icon.get('ariaLabel')}
                backgroundColor={icon.get('backgroundColor')}
                className={styles.asset}
                icon={iconData}
                type={icon.get('shape') === null ? undefined : shapes.ROUND}
            />
        );
    }

    return null;
};

export default Asset;
